// ═══════════════════════════════════════════════════════════════════════════
// Componentes basicos
// Extraído VERBATIM de index.html v0.9.16.
// ═══════════════════════════════════════════════════════════════════════════

import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";


export function NumInput({ value, onChange, style, step, min, max, integer }) {
  const [raw, setRaw] = useState(String(value ?? ""));
  const [focused, setFocused] = useState(false);
  useEffect(() => { if (!focused) setRaw(value === 0 || value === "" ? "" : String(value)); }, [value, focused]);
  return <input
    type="text" inputMode="decimal"
    style={style} step={step} min={min} max={max}
    value={focused ? raw : (value === 0 || value === "" ? "" : String(value))}
    onFocus={() => { setFocused(true); setRaw(value === 0 ? "" : String(value)); }}
    onBlur={() => { setFocused(false); const n = integer ? parseInt(raw) : parseFloat(raw); onChange(isNaN(n) ? 0 : n); }}
    onChange={e => { setRaw(e.target.value); const n = integer ? parseInt(e.target.value) : parseFloat(e.target.value); if (!isNaN(n)) onChange(n); }}
    placeholder="0"
  />;
}

export const Card = ({ children, style, onClick }) => (
  <div onClick={onClick} style={{ background: "#141414", border: "1px solid #1e1e1e", borderRadius: 10, padding: 20, ...style }}>{children}</div>
);

export const Label = ({ children }) => (
  <label style={{ display: "block", fontSize: 11, color: "#888", marginBottom: 5, letterSpacing: 1, textTransform: "uppercase" }}>{children}</label>
);

export const SectionTitle = ({ children, sub }) => (
  <div style={{ marginBottom: 20 }}>
    <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 26, fontWeight: 400, color: "#c9a96e", margin: 0, letterSpacing: 1 }}>{children}</h2>
    {sub && <p style={{ fontSize: 13, color: "#555", marginTop: 4 }}>{sub}</p>}
  </div>
);
